import { ExtAttachmentType } from 'api/extForms';
import * as yup from 'yup';
import { getPdfValidationData, readFile } from '../../../helpers';

const createYupFile = (attachment: ExtAttachmentType) =>
  yup
    .mixed()
    .test('is-valid-size', 'common:formErrors.fileIsTooLarge', value => {
      const file = value as File;
      if (!file?.size) return true; // when file is not provided, return true
      return file?.size <= attachment.maxSize * 1024;
    })
    .test('is-valid-type', 'common:formErrors.invalidFileExtension', value => {
      const file = value as File;
      if (!file?.type) return true; // when file is not provided, return true
      return attachment.types.some(type => file.type.includes(type));
    })
    .test(
      'is-valid-encryption',
      'common:formErrors.fileIsEncrypted',
      async value => {
        const file = value as File;
        if (file?.type !== 'application/pdf') return true; // when file is not pdf, return true

        const buffer = await readFile(file, 'arrayBuffer');
        const { isEncrypted } = await getPdfValidationData(buffer);

        return !isEncrypted;
      },
    );

export const getAttachmentsSchema = (
  fileDescriptions: ExtAttachmentType[] = [],
) =>
  yup.object(
    fileDescriptions.reduce(
      (acc, item) => ({
        [`${item.uuid}`]: item.required
          ? createYupFile(item).required('common:formErrors.required')
          : createYupFile(item),
        ...acc,
      }),
      {},
    ),
  );
